import styled from 'styled-components';
import type { LayerTypes } from './globals';
import { ALERT, FOCUS_LARGE, FOCUS_SMALL, FULLSCREEN } from './globals';
import { responsiveStyles } from '../utils/responsiveStyles';
import { breakpoints } from '../utils/breakpoints';
import {
  SYS_SPACE_FIXED_600,
  SYS_SPACE_FIXED_700,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_FIXED_800,
} from '@oneaudi/unified-web-common';
const stylesContent = {
  [ALERT]: {
    m: SYS_SPACE_FIXED_600,
    s: SYS_SPACE_FIXED_350,
    xs: SYS_SPACE_FIXED_200,
  },
  [FOCUS_LARGE]: {
    xl: SYS_SPACE_FIXED_800,
    l: SYS_SPACE_FIXED_700,
    m: SYS_SPACE_FIXED_600,
    s: SYS_SPACE_FIXED_350,
    xs: SYS_SPACE_FIXED_200,
  },
  [FOCUS_SMALL]: {
    xl: SYS_SPACE_FIXED_800,
    l: SYS_SPACE_FIXED_700,
    m: SYS_SPACE_FIXED_600,
    s: SYS_SPACE_FIXED_350,
    xs: SYS_SPACE_FIXED_200,
  },
  [FULLSCREEN]: {
    xs: '0px 0px 0px 0px',
  },
};

const OneLayerContent = styled.div<{ type: LayerTypes; hasPadding?: boolean }>`
  // default display padding true
  ${({ type, hasPadding = true }): string =>
    stylesContent[type] &&
    responsiveStyles({ padding: hasPadding ? stylesContent[type] : '0' }, breakpoints)}
`;

export default OneLayerContent;
